export default __webpack_public_path__ + "src/assets/tx-pool.7ae11db5d632053b8a814080aa915b5b.svg";